// src/context/KioskDraftContext.js
// The walk-in being entered on the kiosk tablet (customer name, email, phone,
// vehicle, time). Held in memory only: never in the URL, browser history or
// storage, so the next person at the tablet cannot bring it back. Cleared on
// the kiosk home screen, after inactivity, and once the booking is made.
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const KioskDraftContext = createContext(null);

export const KioskDraftProvider = ({ children }) => {
  const [draft, setDraft] = useState({});
  const updateDraft = useCallback((fields) => setDraft((current) => ({ ...current, ...fields })), []);
  const clearDraft = useCallback(() => setDraft({}), []);
  const value = useMemo(() => ({ draft, updateDraft, clearDraft }), [draft, updateDraft, clearDraft]);
  return <KioskDraftContext.Provider value={value}>{children}</KioskDraftContext.Provider>;
};

export const useKioskDraft = () => useContext(KioskDraftContext);
